export const specialPackageIdList = [38, 39, 40, 41, 42, 43];
